import { Application } from "@hotwired/stimulus";

const application = Application.start();

application.debug = false;
window.Stimulus = application;

import TermController from "./term_controller";
application.register("term", TermController);

import DatalayerpushController from "./datalayerpush_controller.js";
application.register("datalayerpush", DatalayerpushController);

import EmulatorModalTriggerController from "./emulator/modal_trigger_controller.js";
application.register("emu-modal-trigger", EmulatorModalTriggerController);

import GamePlayController from "./classic_games/play_controller.js";
application.register("game-play", GamePlayController);

import GamePlaySPController from "./classic_games/play_sp_controller.js";
application.register("game-play-sp", GamePlaySPController);

import KeybindLabellController from "./classic_games/keybind_label_controller.js";
application.register("keybind-label", KeybindLabellController);

import RestrictInputController from "./classic_games/restrict_input_controller.js";
application.register("restrict-input", RestrictInputController);

import ButtonSelectionPreventionController from "./classic_games/button_selection_prevention_controller.js";
application.register("button-selection-prevention", ButtonSelectionPreventionController);

import CcpaController from "./ccpa_controller";
application.register("ccpa", CcpaController);
